import { useUploadFile } from 'xen/api/use-file';
import { getTenantFromUrl } from 'xen/helpers';
export const useCreateTenantMarketingColumnImage = () => {
    return useUploadFile(`/v2/tenants/${getTenantFromUrl()}/marketing_column_images`);
};
